import React, { Component } from 'react';

import SectionList from './Section/SectionList';
import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';

class SectionUnits extends Component {

  render() {

    const { $$data, barOffset, horizontalOffset, width } = this.props;

    const align = 'left';

    const barColor = '#e24b4b';

    const listProps = {id: 'poles', data: $$data, barOffset, align, className: 'SectionUnits', title: 'Nos Pôles d\'Expertise', titleIcon: 'units', titleColor: '#6b6b6b', sectionBg: true, titleSize: width};
    return (
      <SectionList header={<div style={{height: 100}}>
        <SectionCorner length={50} style={{marginLeft: -58}} corner={'bl'} color={barColor} />
        <SectionBar length={Math.round(barOffset/2)} style={{top: 48, marginLeft: ((barOffset-horizontalOffset)*-1)}} color={barColor} direction={'horizontal'}/>
        <SectionCorner length={50} style={{top: 58, marginLeft: (((barOffset)*-1))}} corner={'tl'} color={barColor}/>
      </div>
    } barColor={barColor} style={this.props.style || {}} {...listProps}  />
  );
}
}

export default SectionUnits;



// WEBPACK FOOTER //
// ./src/components/Home/SectionUnits.jsx